import api from '@/api/payments'
import commissionApi from '@/api/commissions'

const getDefaultState = () => {
  return {
    cardHolder: '',
    cardExpirationMonth: '',
    cardExpirationYear: '',
    cardType: 0,
    cardNumber: '',
    cardCvv: '',
    cardBrand: '',
    commissionType: '',
    commissionAmount: '',
    saleOrderId: 0,
    saleOrderTotal: null
  }
}

const state = getDefaultState()

const mutations = {
  SET_CARD_TYPE: (state, value) => { state.cardType = value },
  SET_CARD_NUMBER: (state, value) => { state.cardNumber = value },
  SET_CARD_HOLDER: (state, value) => { state.cardHolder = value },
  SET_CARD_EXPIRATION_MONTH: (state, value) => { state.cardExpirationMonth = value },
  SET_CARD_EXPIRATION_YEAR: (state, value) => { state.cardExpirationYear = value },
  SET_CARD_CVV: (state, value) => { state.cardCvv = value },
  SET_CARD_COMMISSION: (state, commission) => {
    state.commissionAmount = commission.amount
    state.commissionType = commission.type
    state.cardBrand = commission.brand
  },
  SET_SALE_ORDER: (state, saleOrder) => {
    state.saleOrderId = saleOrder.id
    state.saleOrderTotal = saleOrder.total
  },
  CLEAN_CARD: (state) => {
    state.cardHolder = ''
    state.cardExpirationMonth = ''
    state.cardExpirationYear = ''
    state.cardNumber = ''
    state.cardCvv = ''
    state.cardBrand = ''
  }
}

const actions = {
  async preparePayment ({ commit, getters, rootGetters }) {
    const params = {
      product_id: rootGetters['products/selectedProduct'].id,
      vehicle_id: rootGetters['vehicles/selectedVehicle'].id,
      card: getters.card.number,
      card_type: getters.card.type
    }
    try {
      const { data } = await api.preparePayment(params)
      commit('SET_SALE_ORDER', data)
    } catch (error) {
    }
  },
  async prepareRechargePayment ({ commit, getters, rootGetters }, amount) {
    const params = {
      product_id: rootGetters['products/rechargeProduct'].id,
      amount: amount,
      card: getters.card.number,
      card_type: getters.card.type
    }
    try {
      const { data } = await api.preparePayment(params)
      commit('SET_SALE_ORDER', data)
    } catch (error) {
    }
  },
  async performPayment ({ commit, getters, rootGetters }) {
    const payment = {
      sale_order_id: rootGetters['sales/id'],
      cvv: getters.card.cvv
    }
    try {
      const { data } = await api.performPayment({ payment })
      commit('SET_SALE_ORDER', data)
      commit('sales/SET_SALE', data, { root: true })
      commit('sales/ALREADY_PROCESSED', true, { root: true })
      commit('SET_CARD_NUMBER', '')
      commit('SET_CARD_EXPIRATION_MONTH', '')
      commit('SET_CARD_EXPIRATION_YEAR', '')
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response.status === 405) {
          const { data } = error.response
          commit('SET_SALE_ORDER', data)
          commit('sales/SET_SALE', data, { root: true })
          commit('sales/ALREADY_PROCESSED', true, { root: true })
          commit('SET_CARD_NUMBER', '')
          commit('SET_CARD_EXPIRATION_MONTH', '')
          commit('SET_CARD_EXPIRATION_YEAR', '')
          commit('sales/SET_STATUS', 'Duplicada', { root: true })
        }
        if (error.response.status === 422) {
          const { data } = error.response
          commit('sales/ERROR_ON_SALE', data.message, { root: true })
          commit('SET_CARD_NUMBER', '')
          commit('SET_CARD_EXPIRATION_MONTH', '')
          commit('SET_CARD_EXPIRATION_YEAR', '')
        }
      }
    }
  },
  async updateCardNumber ({ commit, dispatch }, value) {
    commit('SET_CARD_NUMBER', value)
  },
  async updateCardCommission ({ commit, dispatch, state }) {
    try {
      const { data } = await commissionApi.getCardCommission(state.cardNumber)

      commit('SET_CARD_COMMISSION', data)

      dispatch('saleOrderForm/updateCommissionValue', parseFloat(data.amount), { root: true })
    } catch (error) {
    }
  },
  updateCardType ({ commit }, value) {
    commit('SET_CARD_TYPE', value)
  },
  updateCardHolder ({ commit }, value) {
    commit('SET_CARD_HOLDER', value)
  },
  updateCardExpirationMonth ({ commit }, value) {
    commit('SET_CARD_EXPIRATION_MONTH', value)
  },
  updateCardExpirationYear ({ commit }, value) {
    commit('SET_CARD_EXPIRATION_YEAR', value)
  },
  updateCardCvv ({ commit }, value) {
    commit('SET_CARD_CVV', value)
  },
  cleanCard ({ commit }) {
    commit('CLEAN_CARD')
  }
}

const getters = {
  card: state => {
    return {
      holder: state.cardHolder,
      type: state.cardType,
      number: state.cardNumber,
      expirationMonth: state.cardExpirationMonth,
      expirationYear: state.cardExpirationYear,
      cvv: state.cardCvv,
      brand: state.cardBrand
    }
  },
  commission: state => {
    return {
      amount: state.commissionAmount,
      type: state.commissionType
    }
  },
  saleOrderPrepared: state => (state.saleOrderId > 0) && (state.saleOrderTotal > 0),
  saleOrder: state => {
    return {
      id: state.saleOrderId,
      total: state.saleOrderTotal
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
